module.exports = __webpack_public_path__ + "static/spiritual_capital_book-bad3e46ef42695b412e8b439f1e433f7.jpg";